<template>
  <AcademicCardsChapter
    page-title="国际学术交流"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhuguojixueshujiaoliu',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '1982—2012 年国际访问与合作',
          summary: '从施拉姆访问到中法合作圆桌会议，研究所早期国际交流兼具学术访问、联合研讨与海外调研三种形态。',
          columns: 2,
          cards: [
            {
              title: '1982 年施拉姆访问新闻研究所',
              src: require('./assets/html/global-1982-schramm.jpg'),
              description: '1982 年 5 月 3 日，施拉姆访问新闻研究所。'
            },
            {
              title: '1991 年日本学者访问新闻研究所',
              src: require('./assets/html/global-1991-japan.jpg'),
              description: '1991 年 9 月，日本学者应邀访问新闻研究所。'
            },
            {
              title: '1992 年访问澳大利亚',
              src: require('./assets/html/global-1992-australia.jpg'),
              description: '1992 年，陈崇山、王怡红访问澳大利亚。'
            },
            {
              title: '1997 年莫斯科学术研讨会',
              src: require('./assets/html/global-1997-moscow.jpg'),
              description: '1997 年，喻权域在莫斯科参加学术研讨会。'
            },
            {
              title: '2010 年北海道大学主题演讲',
              src: require('./assets/html/global-2010-hokkaido.jpg'),
              description: '2010 年 1 月，尹韵公访问北海道大学并做主题演讲。'
            },
            {
              title: '1999 年访问美国',
              src: require('./assets/html/global-1999-postman.jpg'),
              description: '1999 年，卜卫访问美国，与尼尔·波兹曼合影。'
            },
            {
              title: '2012 年中法合作圆桌会议',
              src: require('./assets/html/global-2012-france-roundtable.jpg'),
              description: '2012 年 5 月，唐绪军参加中法合作圆桌会议。'
            }
          ]
        },
        {
          title: '2014—2018 年论坛、访问与代表团交流',
          summary: '近年国际学术交流逐步转向国际论坛、代表团接待与议题合作，覆盖互联网治理、发展传播与传媒技术变迁等方向。',
          columns: 2,
          cards: [
            {
              title: '2016 年中国社会科学论坛',
              src: require('./assets/html/global-2016-forum.jpg'),
              description: '2016 年 8 月，中国社会科学论坛“信息传播技术、发展与社会变革”举行。'
            },
            {
              title: '2014 年 Klaus Beck 一行访问',
              src: require('./assets/html/global-2014-klaus-beck.jpg'),
              description: '2014 年 5 月，Klaus Beck 一行访问新闻与传播研究所。'
            },
            {
              title: '2012 年德国媒体代表团访问',
              src: require('./assets/html/global-2012-german-delegation.jpg'),
              description: '2012 年 12 月，德国媒体代表团访问新闻与传播研究所。'
            },
            {
              title: '2014 年访问美国并与 Ethan Zuckerman 合影',
              src: require('./assets/html/global-2014-zuckerman.jpg'),
              description: '2014 年 10 月，殷乐访问美国，与 Ethan Zuckerman 合影。'
            },
            {
              title: '2016 年首届中外合作互联网治理论坛',
              src: require('./assets/html/global-2016-governance-forum.jpg'),
              description: '2016 年 10 月，“首届中外合作互联网治理论坛”举行。'
            },
            {
              title: '2016 年访问哥本哈根大学',
              src: require('./assets/html/global-2016-copenhagen.jpg'),
              description: '2016 年 12 月，赵天晓率团访问哥本哈根大学。'
            },
            {
              title: '2018 年接待发展中国家新媒体代表团',
              src: require('./assets/html/global-2018-developing-countries.jpg'),
              description: '2018 年 7 月，唐绪军接待周边发展中国家新媒体代表团。'
            }
          ]
        }
      ]
    };
  }
};
</script>
